import Vue from 'vue'
import App from './App'

new Vue({
  el: 'body',
  components: { App }
})




// WEBPACK FOOTER //
// ./src/module/case/case.js